import React from "react";
import PensilIcon from "../icons/BusinessHub/PensilIcon";
import TrashIcon from "../icons/BusinessHub/TrashIcon";
import { MdDragIndicator } from "react-icons/md";

function CategoryRow({
  category,
  isSelected,
  isDragging,
  isDragOver,
  onSelect,
  onDragStart,
  onDragOver,
  onDragEnter,
  onDrop,
  onDragEnd,
  onToggleVisibility,
  onEdit,
  onDelete,
}) {
  return (
    <div
      className={`category-settings-row ${
        isSelected ? "category-settings-row-selected" : ""
      } ${isDragging ? "category-settings-row-dragging" : ""} ${
        isDragOver ? "category-settings-row-drag-over" : ""
      }`}
      draggable
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDragEnter={onDragEnter}
      onDrop={onDrop}
      onDragEnd={onDragEnd}
      onClick={onSelect}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onSelect();
        }
      }}
    >
      <div
        className="category-settings-drag-handle"
        aria-label={`Reorder ${category.categoryName}`}
        title="Drag to reorder"
      >
        <MdDragIndicator />
      </div>
      <div className="category-settings-row-main">
        <div className="category-settings-row-name">
          {category.categoryName}
        </div>
        <div className="category-settings-row-meta">
          <span>{category.visible ? "Displayed" : "Hidden"}</span>
        </div>
        {category.description ? (
          <div className="category-settings-row-description">
            {category.description}
          </div>
        ) : null}
        <div className="category-settings-row-count">
          {category.subCategories.length} subcategories
        </div>
      </div>

      <label
        className="category-settings-checkbox-label"
        onClick={(e) => e.stopPropagation()}
      >
        <input
          type="checkbox"
          checked={category.visible}
          onChange={onToggleVisibility}
        />
        <span>Display to Users</span>
      </label>

      <div className="category-settings-row-actions">
        <button
          className="category-settings-icon-btn"
          aria-label={`Edit ${category.categoryName}`}
          onClick={(e) => {
            e.stopPropagation();
            onEdit();
          }}
        >
          <PensilIcon />
        </button>
        <button
          className="category-settings-icon-btn category-settings-delete-btn"
          aria-label={`Delete ${category.categoryName}`}
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
        >
          <TrashIcon fill="#d92d20" />
        </button>
      </div>
    </div>
  );
}

export default CategoryRow;
